(function ($) {
  $(document).ready(function () {

    var setProductSpace = function () {
      if ($(window).width() > 768) {
        const addedHeight = $(".product-information .product__content").height();
        $(".addToCart").css({ "top": addedHeight + 190 });
        $(".product-information").css({"min-height": addedHeight + 500});
      }else{
        $(".addToCart").css({ "top": "-10px" });
      }
    }
  
    $(window).on('load', setProductSpace);
    $(window).resize(setProductSpace);

    var setVideoHeight = function () {
      if ($(window).width() > 768) {
      let imageHeight = $('.image-_video').find("#same-size").innerHeight();
      $(".image-_video").find("#do-same-size").css({"height": imageHeight});
      }
    }
    
    $(window).on('load', setVideoHeight);
    $(window).resize(setVideoHeight);

    if ($(".product_media_slider_desktop").length >= 1) {
      $(".product_media_slider_desktop").slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrow: false,
      });
    }

    if ($(".product_media_slider_mobile").length >= 1) {
      $(".product_media_slider_mobile").slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        asNavFor: ".product__content__mobile",
      });
    }

    if ($(".product__content__mobile").length >= 1) {
      $(".product__content__mobile").slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: ".product_media_slider",
        arrow: false,
      });
    }

    if ($(".icons_slider").length >= 1) {
      $(".icons_slider").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: true,
        arrow: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      })
    }

    if ($(window).width() < 992) {
      $(".future_item__holder .title").click(function () {
        $(this).next().slideToggle(600);
        $(this).toggleClass("active");
      });
    }

    if ($(window).width() > 992) {
      $(".accordion-body .accordion-title").click(function () {
        $(this).next().slideToggle(300);
        $(this).toggleClass("active");
      });
    }

    $(".custom_number_nav li").click(goToSlide);
    $(".custom_scroller .bar").click(goToSlide);

    function goToSlide() {
      var goToThisIndex = $(this).data("slick-index");
      $(".product_media_slider").slick("slickGoTo", goToThisIndex, false);
    }

    $(".product_media_slider").on("init reInit beforeChange", setActive);

    function setActive(event, slick, currentSlide, nextSlide) {
      $(".custom_number_nav li").removeClass("active");
      $(".custom_scroller .bar").removeClass("active");
      
      $(`[target-id=slick-slide0${nextSlide}]`).addClass("active");
    }


      let videoSection = $(".image-_video");
      let videoContainer = videoSection.find(".video-on-click");
      let videoo = videoSection.find("video").get(0);
      let buttonHolder = videoSection.find(".button-holder");
      let playBtn = videoSection.find("#play");
      let pauseBtn = videoSection.find("#pause");
    
    
      playBtn.click(function(){
        videoo.play(); 
        buttonHolder.css({"display": "none"});
      });

    videoSection.find("video").click(function(){
      if(videoo.paused){
        videoo.play();
        buttonHolder.css({"display": "none"});
      }else{
        videoo.pause();
        buttonHolder.css({"display": "block"});
      }
    })

    // function start_slick(){
    //   console.log('test carousel');
    //   $(".product-recommendations .cards").slick({
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     dots: false,
    //     arrow: false,
    //     responsive: [
    //       {
    //         breakpoint: 620,
    //         settings: {
    //           slidesToShow: 1,
    //           slidesToScroll: 1,
    //           dots: true,
    //           arrow: false
    //         }
    //       }
    //     ]
    //   });
    // }
    // window.setTimeout( start_slick, 2000 );
    
  });

  $('.product__image_with_text--acc .faq-body-c').click(function () {
    $(this).find(".faq-answer").slideToggle(400);
    $(this).toggleClass("active");
  });

  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  if ($(window).width() < 768) {
    $(".faq-body").click(function () {
      $(this).find(".faq-answer").slideToggle(400);
      $(this).toggleClass("active");
    });

    if($(".product-information").length) {
    var lastScrollTop = 0;
    var stickyOffset = $(".product-information").offset().top + $(".product-information").outerHeight(true) + 200;
    
    $(window).bind('scroll', function() {
      var st = $(window).scrollTop();

      if(st > 90){
        $("#shopify-section-header").addClass("fixed");
      }else{
        $("#shopify-section-header").removeClass("fixed");
      }

      if (st < lastScrollTop){
        $("#shopify-section-header").addClass("visible-from-top");
      }else{
        $("#shopify-section-header").removeClass("visible-from-top");
      }

      lastScrollTop = st;

      if($(".product-form").length > 0){

        if(st > stickyOffset) {
          if ($('product-form').isInViewport()) {
            $(".sticky-custom-form").removeClass("show");
          } else {
            $(".sticky-custom-form").addClass("show");
          }
        } else {
          //$(".product-form").removeClass("fixed");
          $(".sticky-custom-form").removeClass("show");
        }
        
        // if(st > stickyOffset){
        //   //$(".product-form").addClass("fixed");
        //   $(".sticky-custom-form").addClass("show");
        // } else {
        //   //$(".product-form").removeClass("fixed");
        //   $(".sticky-custom-form").removeClass("show");
        // }
      }
      
    });
    }

  }
 
  $(".popup").find(".popup-btn").click(function(e){
    e.preventDefault();
    $(this).closest(".popup").find(".popup_div").css({"display": "flex"});
  })


  $(".popup").find(".cross_btn").click(function(){
    $(this).closest(".popup_div").css({"display": "none"});
  })

  $(function () {
		$(".card-box").slice(0, 16).show();
		$("body").on('click touchstart', '#loadmore', function (e) {
			e.preventDefault();
			$(".card-box:hidden").slideDown();
			if ($(".card-box:hidden").length == 0) {
				$(".loadmore__holder").hide();
			}
			
		});
	});


  $(".submenu-container--links .left-links ul li a").on("mouseover", function () {
    const link = $(this).attr('data-link');

    $('.right-links ul').hide();
    $('.right-links ul[data-menu="'+link+'"]').css('display', 'flex');
  });

  $('.mobile-link-button').on("click", function () {
    $(this).next().attr('aria-hidden', true).addClass('active');
  });
  $('.mobile-back').on("click", function () {
    $(this).parent().attr('aria-hidden', false).removeClass('active');
  });
  

})(jQuery);
